import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createProductVariant = async (formValues) => {
  const formData = new FormData();
  formData.append("ProductId", formValues.ProductId);
  formData.append("ColorId", formValues.ColorId);
  formData.append("DiscountPrice", formValues.DiscountPrice);
  formData.append("ActualPrice", formValues.ActualPrice);
  formData.append("ProductSize", formValues.ProductSize);
  formData.append("MaxQuantity", formValues.MaxQuantity);
  formData.append("BestSeller", formValues.BestSeller);
  formData.append("InStock", formValues.InStock);
  formData.append("Featured", formValues.Featured);
  formData.append("Published", formValues.Published);

  if (formValues.ProductImageFile) {
    formData.append("ProductImageFile", formValues.ProductImageFile);
  }
  const response = await axiosInstance.post("product/variant", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateProductVariant = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("ProductId", formValues.ProductId);
  formData.append("ColorId", formValues.ColorId);
  formData.append("DiscountPrice", formValues.DiscountPrice);
  formData.append("ActualPrice", formValues.ActualPrice);
  formData.append("ProductSize", formValues.ProductSize);
  formData.append("MaxQuantity", formValues.MaxQuantity);
  formData.append("BestSeller", formValues.BestSeller);
  formData.append("InStock", formValues.InStock);
  formData.append("Featured", formValues.Featured);
  formData.append("Published", formValues.Published);

  if (formValues.ProductImageFile) {
    formData.append("ProductImageFile", formValues.ProductImageFile);
  }
  const response = await axiosInstance.put("product/variant", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchProductsVariantByProductId = async (productId) => {
  const response = await axiosInstance.get(`product/${productId}/variants`, {
    headers,
  });
  return response.data;
};

export const fetchProductsVariants = async (productId) => {
  const response = await axiosInstance.get(`product/variants`, {
    headers,
  });
  return response.data;
};
export const fetchProductVariantById = async (id) => {
  const response = await axiosInstance.get(`product/variant/${id}`, {
    headers,
  });
  return response.data;
};

export const publishProductVariant = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/publish`, {
    headers,
  });
};

export const unPublishProductVariant = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/unpublish`, {
    headers,
  });
};

export const markProductVariantFeatured = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/featured`, {
    headers,
  });
};
export const markProductVariantUnFeatured = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/unfeatured`, {
    headers,
  });
};

export const markProductVariantInStock = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/in-stock`, {
    headers,
  });
};
export const markProductVariantOutOfStock = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/out-of-stock`, {
    headers,
  });
};

export const markProductVariantBestSeller = async (id) => {
  return await await axiosInstance.patch(`product/variant/${id}/best-seller`, {
    headers,
  });
};
export const markProductVariantNotaBestSeller = async (id) => {
  return await await axiosInstance.patch(
    `product/variant/${id}/not-a-best-seller`,
    {
      headers,
    }
  );
};

export const deleteProductVariant = async (id) => {
  return await axiosInstance.delete(`product/variant/${id}`, { headers });
};
